var alertTriggersList = {
	caption: "Liste des Alertes",
	noResultsMessage: "Aucun résultat trouvé",
	actions: "Actions",
	trigger: {
		dateTime: "Date de création",
		limits: "Limites",
		limitAbove: "Limite supérieure",
		limitBelow: "Limite inférieure"
	},
	security: {
		name: "Nom",
		isin: "ISIN",
		lastPrice: "Dernier prix",
		lastPriceDateTime: "Date/Heure",
		assetClass: "Classe d'actifs",
		exchange: "Marché/bourse"
	}
};
var fr = {
	alertTriggersList: alertTriggersList
};

export { alertTriggersList, fr as default };
